module.exports = __webpack_public_path__ + "img/1.65fbcc08.jpg";